import { useEffect } from 'react';
import { useTheme } from '@/context/ThemeProvider';
import useUserStore from '@/stores/UserStore';

const ORGANIZATION = 'sbccrm';

const FeaturebaseChangelogWidget = () => {
  const { currentTheme } = useTheme();
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (user?.email && user?.featurebase_hash) {
      const win = window;
      if (typeof win.Featurebase !== 'function') {
        win.Featurebase = function () {
          // eslint-disable-next-line prefer-rest-params
          (win.Featurebase.q = win.Featurebase.q || []).push(arguments);
        };
      }

      win.Featurebase(
        'init_changelog_widget',
        {
          organization: ORGANIZATION,
          popup: {
            enabled: true,
            usersName: `${user.first_name} ${user.last_name}`.trim(),
          },
          theme: currentTheme,
          locale: 'en',
        },
        (err) => {
          if (err) {
            console.error(
              'Featurebase changelog widget initialization failed',
              err
            );
          } else {
            console.log('Featurebase changelog widget initialized');
          }
        }
      );
    }
  }, [currentTheme, user]);

  return null;
};

export default FeaturebaseChangelogWidget;
